import { render, staticRenderFns } from "./BusinessProcess.vue?vue&type=template&id=1ada1bc5&scoped=true"
import script from "./BusinessProcess.vue?vue&type=script&lang=js"
export * from "./BusinessProcess.vue?vue&type=script&lang=js"
import style0 from "./BusinessProcess.vue?vue&type=style&index=0&id=1ada1bc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada1bc5",
  null
  
)

export default component.exports